module.exports = __webpack_public_path__ + "img/course-cover04.38443cee.jpg";